import DefaultLayout from "../../components/layouts/default-layout/DefaultLayout";
import { Route, useSearchParams } from "react-router-dom";
import StudentExtraCurricularRoute from "../../routes/student-extra-curricular/StudentExtraCurricularRoute";
import RewardRoute from "../../routes/rewards/RewardRoute";
import PointGuide from "../../components/management/point-guide/PointGuide";
import ReceivedRewards from "../../components/management/received-rewards/ReceivedRewards";
import EmptyLayout from "../../components/layouts/empty-layout/EmptyLayout";
import { DefaultLayoutHeaderType } from "../../components/layouts/default-layout/DefaultLayout.models";
import AboutInstitution from "../../routes/about-institution/AboutInstitution";
import LecturerInfoRoute from "../../routes/lecturer-info/LecturerInfoRoute";
import TopUsers from "../../components/content/top-users/TopUsers";
import EducationalBookletDetailsRoute from "../../routes/educational-booklet/EducationalBookletDetailsRoute";
import CourseNoteCategoriesRoute from "../../routes/course-note/CourseNoteCategoriesRoute";
import CourseNoteListRoute from "../../routes/course-note/CourseNoteListRoute";
export default function ContentRoute() {
  const [searchParams] = useSearchParams();
  return (
    <>
      <Route
        element={
          <DefaultLayout
            showFooter={true}
            showDefaultHeader={DefaultLayoutHeaderType.showDefaultHeader}
          />
        }
      >
        <Route
          path="/StudentExtraCurricular"
          element={<StudentExtraCurricularRoute statusPage={"0"} />}
        />
      </Route>

      <Route
        element={
          <DefaultLayout
            showContactUs={false}
            backUri={"/StudentExtraCurricular"}
            title={"تدریس های برنده ساز"}
          />
        }
      >
        <Route
          path="/CourseNote"
          element={<StudentExtraCurricularRoute statusPage={"2"} />}
        />
      </Route>

      <Route
        element={
          <DefaultLayout
            showContactUs={false}
            backUri={"/CourseNote"}
            title={"تدریس های برنده ساز"}
          />
        }
      >
        <Route
          path="/CourseNoteCategories"
          element={
            <CourseNoteCategoriesRoute
              courseId={searchParams.get("courseId")}
            />
          }
        />
      </Route>

      <Route
        element={
          <DefaultLayout
            showContactUs={false}
            backUri={`/CourseNoteCategories?courseId=${searchParams.get("courseId") ?? ""}`}
            title={""}
          />
        }
      >
        <Route
          path="/CourseNoteList"
          element={
            <CourseNoteListRoute
              courseId={searchParams.get("courseId")}
              categoryId={searchParams.get("categoryId")}
            />
          }
        />
      </Route>

      <Route
        element={
          <DefaultLayout
            showContactUs={false}
            backUri={"/StudentExtraCurricular"}
            title={"کوچینگ من"}
          />
        }
      >
        <Route
          path="/EducationalBooklet"
          element={<StudentExtraCurricularRoute statusPage={"3"} />}
        />
      </Route>

      <Route
        element={
          <DefaultLayout
            showContactUs={false}
            backUri={"/EducationalBooklet"}
            title={"کوچینگ"}
          />
        }
      >
        <Route
          path="/EducationalBooklet/Details"
          element={
            <EducationalBookletDetailsRoute
              bookletId={searchParams.get("bookletId")}
            />
          }
        />
      </Route>

      <Route
        element={
          <DefaultLayout
            showContactUs={false}
            backUri={"/StudentExtraCurricular"}
            title={"نکات مشاوره ای"}
          />
        }
      >
        <Route
          path="/SampleTeaching"
          element={<StudentExtraCurricularRoute statusPage={"1"} />}
        />
      </Route>

      <Route
        element={
          <DefaultLayout
            backUri={"/Dashboard"}
            backIcon={"mdi-close"}
            title={"جوایز"}
          />
        }
      >
        <Route
          path="/Rewards"
          element={<RewardRoute statusPage={searchParams.get("statusPage")} />}
        />
      </Route>

      <Route
        element={
          <DefaultLayout
            backUri={"/Rewards?statusPage=3"}
            title="جوایز دریافت شده"
          />
        }
      >
        <Route path="/ReceivedRewards" element={<ReceivedRewards />} />
      </Route>

      <Route
        element={
          <DefaultLayout
            backUri={"/Rewards?statusPage=2"}
            title={"لیست امتیازات اپلیکیشن"}
          />
        }
      >
        <Route path="/PointsGuide" element={<PointGuide />} />
      </Route>

      <Route
        element={
          <DefaultLayout
            title="برترین های برنده ساز"
            backUri={"/MyPerformance"}
          />
        }
      >
        <Route path="/TopStudents" element={<TopUsers />} />
      </Route>

      <Route element={<EmptyLayout />}>
        <Route
          path="/About"
          element={
            <AboutInstitution statusPage={searchParams.get("statusPage")} />
          }
        />
      </Route>

      <Route
        element={
          <DefaultLayout
            showContactUs={false}
            backUri={"/About"}
            title={"اساتید"}
          />
        }
      >
        <Route
          path="/LecturerInfo"
          element={
            <LecturerInfoRoute
              statusPage={searchParams.get("statusPage")}
              userId={searchParams.get("userId")}
              authorId={searchParams.get("authorId")}
            />
          }
        />
      </Route>
    </>
  );
}
